import { phone } from '../../../phone/usePhone';
import { deviceContacts } from '../../../utils/deviceContacts';
import { ChatCommand } from '../types';

const handlePhoneCommand = async (cmd: ChatCommand) => {
  const { number, mode = 'dial', contact } = cmd.data;
  let numberToCall = number;

  // Include a delay so that messages can be seen before the number is dialed
  const delay = parseInt(cmd.data.delay || '3000');

  if (contact && contact.name && contact.number) {
    numberToCall = contact.number;

    // Check if a contact with the phone number already exists
    const existingContacts = await deviceContacts.getContactByPhoneNumber(
      numberToCall
    );

    // If no matching contact exists, create a new one
    if (existingContacts.length === 0) {
      await deviceContacts.addContact(contact);
    }
  }

  if (numberToCall) {
    if (mode === 'dial') {
      setTimeout(() => phone.dialNumber(numberToCall), delay);
    } else if (mode === 'instant_call') {
      setTimeout(() => phone.callNumber(numberToCall), delay);
    }
  }
};

export default handlePhoneCommand;
